/**
 *  @author Eugene Terentev <eugene@terentev.net>
 */

if ($('.wrap .container').offset().top > 50) $('.navbar-inverse').addClass('topWhite');

if ($('div').is('#w0')) $('#w0').delay(3000).fadeOut('slow');

$(window).on('scroll', function(){
    if ($('.wrap .container').offset().top > 50) $('.navbar-inverse').addClass('topWhite'); else $('.navbar-inverse').removeClass('topWhite');
    $('.navbar-collapse').slideUp();
});

$(document).on('click', '.wrap > .container', function(){
    $('.navbar-collapse').slideUp();
});


$(document).on('click', '.go', function(){
    var href = $(this).attr('href');
    href = href.split('#');
    console.log( href[1]);
    var positionFromTop = $("#" + href[1]).offset().top;
    if (typeof positionFromTop != 'undefined') {
        if ($('.wrap .container').offset().top > 50) $('.navbar-inverse').addClass('topWhite'); else $('.navbar-inverse').removeClass('topWhite');
	$('html, body').animate({ scrollTop: positionFromTop }, 600);
	$('.navbar-nav > li').removeClass('active');
	$(this).parent().addClass('active');
    }
    return false;
});

// Closes responsive menu when a scroll trigger link is clicked
$(document).on('click', '.navbar-toggle', function(){
    $('.navbar-collapse').slideToggle();
});
          
$(document).on('click', '#w0 .close', function(){
    $('#w0').hide();
    return false;
});
          

